const getters = {
  userInfo: state => state.user.userInfo,
  token: state => state.user.token,
  isLogin: state => state.user.isLogin,
  host: state => state.user.host,
  isActive: state => state.user.isActive,
  carNum: state => state.car.carNum,
  quitQuanId: state => state.user.quitQuanId,
  quitpcQuanId: state => state.user.quitpcQuanId,
  favac: state => state.user.favac
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js